import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';


@Component({
  selector: 'arumid-thankyou',
  templateUrl: './thankyou.component.html',
  styleUrls: ['./thankyou.component.scss']
})
export class ThankyouComponent {
  constructor(
    public dialogRef: MatDialogRef<ThankyouComponent>) {}

  onNoClick(): void {
    this.dialogRef.close();
  }

}
